import * as React from 'react'
import { ConversationMessage, ConversationMessageType } from '../../types'
import Article from './Messenger/Conversations/Message/Article'
import RequestEmail from './Messenger/Conversations/Message/RequestEmail'
import Text from './Messenger/Conversations/Message/Text'
import Note from './Messenger/Conversations/Message/Note'
import Attachment from './Messenger/Conversations/Message/Attachment'
import Gif from './Messenger/Conversations/Message/Gif'
import Typing from './Messenger/Conversations/Message/Typing'

interface IProps {
  message: ConversationMessage
  onPreviewClick?: (url: string) => void
  admin?: boolean
}

const MessageContent = ({ message, onPreviewClick, admin }: IProps) => (
  <>
    {message.type === ConversationMessageType.REQUEST_EMAIL && <RequestEmail message={message} admin={admin} />}
    {message.type === ConversationMessageType.TEXT && <Text message={message} />}
    {message.type === ConversationMessageType.NOTE && <Note message={message} />}
    {message.type === ConversationMessageType.ATTACHMENT && <Attachment message={message} onPreviewClick={onPreviewClick ?? (() => { })} />}
    {message.type === ConversationMessageType.GIF && <Gif message={message} onPreviewClick={onPreviewClick ?? (() => { })} />}
    {message.type === ConversationMessageType.ARTICLE && <Article message={message} admin={admin} />}
    {message.type === ConversationMessageType.TYPING && <Typing message={message} />}
  </>
)

export default MessageContent
